import { ComponentPropsWithoutRef } from 'react'
import { twMerge } from 'tailwind-merge'

export interface LoginButtonProps extends ComponentPropsWithoutRef<'button'> {
    /** `text` for a secondary action such as going back. */
    variant?: 'primary' | 'text'
}

/**
 * The button of an account form in a `LoginBox`, such as logging in or changing a password.
 */
const LoginButton = ({ variant = 'primary', className, ...rest }: LoginButtonProps) => (
    <button
        type="button"
        className={twMerge(
            'cursor-pointer border-none text-md font-bold disabled:cursor-not-allowed',
            variant === 'primary' &&
                'h-9 min-w-[100px] rounded-[5px] bg-[#5788ff] px-2.5 text-white hover:bg-[#4170e8] disabled:bg-[#a9aab3]',
            variant === 'text' &&
                'bg-transparent p-0 text-[#5788ff] hover:text-black disabled:text-[#a9aab3]',
            className,
        )}
        {...rest}
    />
)

export default LoginButton
